import { SharingMode } from '@bringg/types';

export const SHARING_MODES = [
	{
		label: 'All methods',
		value: SharingMode.ALL
	},
	{
		label: 'Only via email',
		value: SharingMode.EMAIL_ONLY
	},
	{
		label: 'Only via SMS',
		value: SharingMode.PHONE_ONLY
	},
	{
		label: 'Do not share with customer',
		value: SharingMode.NO_SHARING
	},
	{
		label: 'Only webhook',
		value: SharingMode.WEBHOOKS_ONLY
	}
];
